import { useQuery } from '@tanstack/react-query'
import { useApiClient } from '@/shared/api'

// Event types from LiveKit event logger
export interface EventLogEntry {
  timestamp: string
  log_level: string
  event_type: string
  title: string
  call_id: string
  event_data: Record<string, unknown>
}

export interface EventsLogResponse {
  call_id: string
  events: EventLogEntry[]
  raw_log: string | null
  error?: string
  total_events: number
}

/**
 * Hook to fetch event logs for a call
 * Only available for superadmin users
 */
export function useEventsLog(callId: string | null) {
  const apiClient = useApiClient();

  return useQuery({
    queryKey: ['events-log', callId],
    queryFn: async () => {
      return apiClient<EventsLogResponse>(`/events-log?call_id=${callId}`)
    },
    enabled: !!callId,
    // Don't refetch on window focus for logs
    refetchOnWindowFocus: false,
    // Keep stale data longer since logs don't change
    staleTime: 1000 * 60 * 5, // 5 minutes
  })
}